/* eslint no-unused-vars: 0 */

const HOST_NAME = window.location.hostname
const STAGING_API_URL = 'https://api.staging.payadvantage.com.au/latest'
const PRODUCTION_API_URL = 'https://api.payadvantage.com.au/latest'
const CREATE_LEAD_URL = `${(HOST_NAME === 'localhost' || HOST_NAME === 'webstage.payadvantage.com.au') ? STAGING_API_URL : PRODUCTION_API_URL}/webapp/user/createlead`
const GET_PLANS_URL = `${(HOST_NAME === 'localhost' || HOST_NAME === 'webstage.payadvantage.com.au') ? STAGING_API_URL : PRODUCTION_API_URL}/webapp/plans`
const CREATE_SIGNUP_URL = `${(HOST_NAME === 'localhost' || HOST_NAME === 'webstage.payadvantage.com.au') ? STAGING_API_URL : PRODUCTION_API_URL}/webapp/user/createsignup`
